(function () {
  "use strict";
  /* Wade Greens - wishlist icon in the mobile header bar.

     The theme already renders a wishlist link (.header__icon--wishlist ->
     /pages/wish-list) but only inside .header-top--wrapper, the desktop header
     row, which is display:none below the breakpoint. The mobile bar
     (.header-mobile__wrapper) ships logo | search | customer | cart | menu and
     has no wishlist slot, and the section that builds it is 250KB, over the
     API write ceiling.

     So this clones the theme's own anchor - same href, same svg, same classes -
     into a sixth slot before the cart. Nothing is invented and nothing is
     removed; the logo slot flexes from 163px to 115px at 375px and the bar
     still fits with no horizontal overflow.

     The cloned heart draws with stroke="currentColor", which is exactly the
     hook iOS uses to repaint an icon its own link blue. wg-mb-wishlist.css
     pins stroke and -webkit-text-fill-color so it cannot. */

  var BREAKPOINT = 1025;
  var SLOT = "wg-mb-wishlist";

  function build() {
    if (window.innerWidth >= BREAKPOINT) return;
    var bar = document.querySelector(".header-mobile__wrapper");
    if (!bar || bar.querySelector("." + SLOT)) return;
    var cartSlot = bar.querySelector(".header-mobile__item--cart");
    var src = document.querySelector(".header__icon--wishlist");
    if (!cartSlot || !src) return;

    var slot = document.createElement("div");
    slot.className = "header-mobile__item header-mobile__item--wishlist " + SLOT;
    var icon = document.createElement("div");
    icon.className = "header-mobile--icon";
    icon.style.setProperty("--i-color", "#000000");
    var a = src.cloneNode(true);
    a.className = "header__icon header__icon--wishlist link link--text focus-inset";
    icon.appendChild(a);
    slot.appendChild(icon);
    cartSlot.parentNode.insertBefore(slot, cartSlot);
  }

  function remove() {
    var slot = document.querySelector("." + SLOT);
    if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
  }

  function sync() {
    if (window.innerWidth < BREAKPOINT) build();
    else remove();
  }

  function init() {
    sync();
    var t = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(t);
      t = window.setTimeout(sync, 150);
    });
    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(sync, 60);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
